const momentFormat = {
  DATE: 'ddd, MMM D YYYY',
  DATE_TIME: 'ddd, MMM D YYYY [at] HH:mm',
  API: 'YYYY-MM-DD[T]HH:mm:ss'
};

const message = {
  CONTENT_WARNING: 'Your company will still be charged if booking is not Approved',
  NO_POLICY_BREAK: 'Within Policy'
};

const api = {
  root: `${window.apiUrl}`,
  url: `${window.apiUrl}api/`,
  sctApiUrl: `${window.sctApiUrl}api/`,
  iataSct: `${window.apiUrl}api/Itinerary/IataSearchSct`,
  citySearch: `${window.apiUrl}api/Location/city`,
  depotSearch: `${window.apiUrl}api/Car/depots`,
  car: `${window.apiUrl}api/car`,
  carDetails: `${window.apiUrl}api/car/detail`,
  hotels: `${window.apiUrl}api/hotel`,
  hotelPartial: `${window.apiUrl}api/HotelPartial`,
  hotelRates: `${window.apiUrl}api/hotel/rates`,
  hotelReviews: `${window.apiUrl}api/hotel/reviews`,
  hotelPolicy: `${window.apiUrl}api/Hotel/CheckPolicy`,
  token: `${window.apiUrl}Token`,
  flail: `${window.apiUrl}api/Rail/`,
  supplierLocations: `${window.apiUrl}api/supplierLocations/`,
  poi: `${window.apiUrl}api/PointOfInterest`,
  version: 18,
  sctVersion: 1,
};

const API = {
  userActivity: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/activity`;
    }
  },
  userPeople: {
    url: (slugs) => {
      return slugs.id ? `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/travellers/${slugs.id}` : `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/travellers`;
    }
  },
  userProfile: {
    url: `${window.sctApiUrl}api/v${api.sctVersion}/profile`,
  },
  userDebtor: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}`;
    },
  },
  fareForecaster: {
    url: `${window.apiUrl}api/fareforecaster`,
  },
  costCentres: {
    url: `${window.apiUrl}api/CostCentres`,
  },
  department: {
    url: `${window.apiUrl}api/Department`,
  },
  departmentCode: {
    url: `${window.apiUrl}api/Department/departmentCode`,
  },
  settings: {
    url: `${window.apiUrl}api/Setting`,
  },
  travel: {
    url: `${window.apiUrl}api/Travel/search`,
  },
  travelDetail: {
    url: (slugs) => {
      return `${window.apiUrl}api/Travel/${slugs.travelId}/${slugs.type}/details`;
    },
  },
  travelFareRules: {
    url: (slugs) => {
      return `${window.apiUrl}api/Travel/${slugs.travelId}/${slugs.type}/fareclasses/${slugs.fareId}/farerules`;
    },
  },
  travelSeatMap: {
    url: (slugs) => {
      return `${window.apiUrl}api/SeatMap/search`;
    },
  },
  flightInformation: {
    url: (slugs) => {
      return `${window.apiUrl}api/FlightInformation/search`;
    },
  },
  debtorSearch: {
    url: (slugs) => {
      return `${window.apiUrl}api/DebtorSearch`;
    },
  },
  locations: {
    url: (slugs) => {
      return `${window.apiUrl}api/location/poi`;
    },
  },
  userInfo: {
    url: (slugs) => {
      return `${window.apiUrl}api/UserInfo`;
    },
  },
  userInvite: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/invites`;
    },
  },
  userRegister: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/profile/register`;
    },
  },
  forgotPassword: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/resetpassword?email=${encodeURIComponent(slugs.email)}`;
    },
  },
  resetPassword: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/resetpassword/${slugs.token}`;
    },
  },
  completeInvite: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/debtors/${slugs.debtorId}/invites/${slugs.token}/complete`;
    },
  },
  userContact: {
    url: (slugs) => {
      return `${window.sctApiUrl}api/v${api.sctVersion}/support/getintouch?message=${encodeURIComponent(slugs.message)}`;
    },
  },
};

const version = {
  number: window.lbVersion
};

const analytics = {
  enabled: window.ANALYTICS_ENABLED,
  trackingCode: window.ANALYTICS_CODE,
};

const appInsights = {
  enabled: window.APPINSIGHTS_ENABLED,
  key: window.APPINSIGHTS_CODE,
};

const client = {
  id: window.CLIENT_ID,
  secret: window.CLIENT_SECRET
};

const MVC = window.MVC;

const DISABLE_SEATMAPS = window.DISABLE_SEATMAPS;
const FARE_FORECASTER_ENABLED = window.FareForecasterEnabled;
const TICKETS_ON_HOLD_ENABLED = window.TicketsOnHoldEnabled;
const HOTEL_REVIEWS_ENABLED = window.HotelReviewsEnabled;
const THE_VIBE_ENABLED = window.TheVibeEnabled;
const RECENT_SEARCHES_ENABLED = window.RecentSearchesEnabled;
const PREFERRED_FLAG_ENABLED = window.PreferredFlagEnabled;
const ENABLE_ADD_TO_ITINERARY = window.EnableAddToItinerary;
const MOBILE_SPLASH_SCREEN_ENABLED = window.MobileSplashScreenEnabled;

export default {
  APP_NAME: window.APP_NAME,
  analytics: analytics,
  appInsights: appInsights,
  version: version,
  momentFormat: momentFormat,
  message: message,
  APP_URL: window.APP_URL,
  api: api,
  API: API,
  client: client,
  MVC: MVC,
  DISABLE_SEATMAPS,
  RECENT_SEARCHES_ENABLED,
  FARE_FORECASTER_ENABLED,
  TICKETS_ON_HOLD_ENABLED,
  HOTEL_REVIEWS_ENABLED,
  THE_VIBE_ENABLED,
  PREFERRED_FLAG_ENABLED,
  ENABLE_ADD_TO_ITINERARY,
  MOBILE_SPLASH_SCREEN_ENABLED
};



// WEBPACK FOOTER //
// ./src/config/appConfig.js